import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { BASE_URL } from '../constants/constant';
import PaymentSuccess from '../components/PaymentSuccess';

export default function SuccessfullPage() {
  const { txn_id } = useParams();
  const [txnDetail, setTxnDetail] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      const txn_url = `${BASE_URL}success/txn_detail/${txn_id}`;

      try {
        const txnResponse = await axios.get(txn_url);
        setTxnDetail(txnResponse?.data?.data);
      } catch (error) {
        console.log();
        navigate('/pay/not-found');
      }
    };

    if (!txnDetail) {
      fetchData();
    }
    const timer = setTimeout(() => {
      if (txnDetail?.return_url) {
        window.location.href = txnDetail.return_url;
      }
    }, 10000); // 10 seconds

    return () => clearTimeout(timer);
  }, [txnDetail, navigate, txn_id]);
  useEffect(() => {
    const metaThemeColor = document.querySelector("meta[name=theme-color]");
    if (metaThemeColor) {
      metaThemeColor.setAttribute("content", "#144618");
    }

    document.body.style.backgroundColor = '#144618'; // Light grey for ContactPage

    return () => {
      document.body.style.backgroundColor = ''; // Reset to default on unmount
      if (metaThemeColor) {
        metaThemeColor.setAttribute("content", "#ADEE68");
      }
    };
  }, []);
  return (
   <PaymentSuccess txnDetail={txnDetail}/>
  );
}
